import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import Notifications from "../../components/push-notifications/Notifications";
import HelmetWrapper from "../../HelmetWrapper";
import IncentiveStructure from "../../components/incentive-system/incentive-calculations/IncentiveStructure";

const TrainerIncentivesOpen = () => {
  const navigate = useNavigate();
  const isNotificationDenied = useSelector(
    (state) => state.notification.permission
  );

  const [pageState, setPageState] = useState(
    JSON.parse(localStorage.getItem("pageState"))
  );
  const { decryptedText: userInfoData, isCustom } = pageState || {};

  const isIOS = () => {
    return /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;
  };

  useEffect(() => {
    const savedState = localStorage.getItem("pageState");

    if (savedState) {
      try {
        setPageState(JSON.parse(savedState));
      } catch (error) {
        console.error("Error parsing saved state:", error);
      }
    }
  }, []);

  useEffect(() => {
    if (!pageState) {
      navigate("/open-access");
    }
  }, [pageState]);

  return (
    <HelmetWrapper title="WTF: Trainer Incentives">
      {userInfoData && !isIOS() && <Notifications authData={userInfoData} />}
      <IncentiveStructure
        userInfoData={userInfoData}
        isCustom={isCustom}
        isNotificationDenied={isNotificationDenied}
      />
    </HelmetWrapper>
  );
};

export default TrainerIncentivesOpen;
